import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef, Input, type OnInit } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { CustomFieldDTO } from 'src/app/DTO/CustomFieldDTO';
import { AppCurrencyPipeModule } from 'src/app/pipes/CurrencyPipe/CurrencyPipe.pipe.module';

@Component({
  selector: 'app-custom-field-multiselect',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    TranslateModule,
    AppCurrencyPipeModule
  ],
  templateUrl: './multiselect.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
   providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CustomFieldMultiselectComponent),
        multi: true
      }
    ]
})
export class CustomFieldMultiselectComponent implements OnInit, ControlValueAccessor {

  @Input()
  public customField: CustomFieldDTO | null;

  @Input()
  public readonly: boolean;

  public options!: { label: string, value: string, price: number }[];
  public selectedOptions!: string[];

  get selectedOptionsString() {
    return this.selectedOptions.join(', ');
  }

  onChange: (_: string) => void = (_: string) => { };

  ngOnInit(): void { 
    if (this.customField.dropdownType === 'TABLE') {
      this.options = this.customField.dropdownOptionsTable.map(x => ({ label: x.name, value: x.name, price: x.price }));
    } else {
      this.options = this.customField.dropdownOptions.split('|').map(x => ({ label: x, value: x, price: 0 }));
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(): void { }

  writeValue(val: string): void {
    if (this.customField) {
      this.customField.value = val;
    }

    this.selectedOptions = this.modelFromString(val);
  }

  updateChanges(value: any) {    
    console.log(value);
    this.onChange(this.modelToString(value));
  }

  private modelToString(value: string[]) {
    if (!value) { return null; }
    console.log(value.join('|'));
    return value.join('|');
  }

  private modelFromString(value: string): string[] {
    if (!value) { return null; }
    console.log(value);
    return value?.split('|')
  }

}
